export const defaultHandler = (response: Response): Promise<Response> => {
  if (response.ok) {
    return Promise.resolve(response);
  }
  switch (response.status) {
    case 500:
      throw new InternalServerError();
    case 403:
      throw new ForbiddenError();
    case 401:
      throw new NotAuthenticatedError();
    case 400:
      return response.json().then((json) => {
        throw new BadRequestError(json.error, json.fieldErrors);
      });
    default:
      throw new HttpError(response.status, response.statusText);
  }
};

export class HttpError extends Error {
  name: string;

  statusCode: number;

  constructor(statusCode: number, ...rest: Array<any>) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...rest);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpError);
    }
    this.name = "HttpError";

    // Custom debugging information
    this.statusCode = statusCode;
  }
}

export class InternalServerError extends HttpError {
  name: string;

  constructor(...rest: Array<any>) {
    super(500, ...rest);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, InternalServerError);
    }
    this.name = "InternalServerError";
  }
}

export class ForbiddenError extends HttpError {
  name: string;

  constructor(...rest: Array<any>) {
    super(403, ...rest);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ForbiddenError);
    }
    this.name = "ForbiddenError";
  }
}

export class NotAuthenticatedError extends HttpError {
  name: string;

  constructor(...rest: Array<any>) {
    super(401, ...rest);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NotAuthenticatedError);
    }
    this.name = "NotAuthenticatedError";
  }
}

export class BadRequestError extends HttpError {
  name: string;

  error: string;

  fieldErrors: Record<string, string>;

  constructor(error: string, fieldErrors: Record<string, string> = {}, ...rest: Array<any>) {
    super(400, ...rest);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BadRequestError);
    }
    this.name = "BadRequestError";
    this.error = error;
    this.fieldErrors = fieldErrors;
  }
}
